export default __webpack_public_path__ + "static/media/Bolo-De-Maca.6b175bf3.jpg";